import { useEffect, useRef } from "react";

export default function RadarScanner({ onComplete, duration = 3500 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const size = 320;
    canvas.width = size;
    canvas.height = size;
    const cx = size / 2, cy = size / 2, R = size / 2 - 10;
    let angle = 0, raf;
    const start = Date.now();

    const draw = () => {
      ctx.clearRect(0, 0, size, size);
      // rings
      ctx.strokeStyle = "rgba(95,231,255,0.25)";
      ctx.lineWidth = 1;
      for (let i = 1; i <= 4; i++) {
        ctx.beginPath();
        ctx.arc(cx, cy, (R / 4) * i, 0, Math.PI * 2);
        ctx.stroke();
      }
      // crosshairs
      ctx.beginPath();
      ctx.moveTo(cx - R, cy); ctx.lineTo(cx + R, cy);
      ctx.moveTo(cx, cy - R); ctx.lineTo(cx, cy + R);
      ctx.stroke();
      // sweep
      const grad = ctx.createConicGradient ? ctx.createConicGradient(angle, cx, cy) : null;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, R, angle, angle + 0.6);
      ctx.closePath();
      ctx.fillStyle = "rgba(95,231,255,0.28)";
      ctx.fill();
      ctx.restore();
      // sweep line
      ctx.strokeStyle = "rgba(95,231,255,0.9)";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(cx + Math.cos(angle) * R, cy + Math.sin(angle) * R);
      ctx.stroke();
      // random blips
      if (Math.random() > 0.85) {
        const a = Math.random() * Math.PI * 2, d = Math.random() * R;
        ctx.fillStyle = "rgba(226,42,92,0.9)";
        ctx.beginPath();
        ctx.arc(cx + Math.cos(a) * d, cy + Math.sin(a) * d, 3, 0, Math.PI * 2);
        ctx.fill();
      }
      angle += 0.08;
      if (Date.now() - start < duration) raf = requestAnimationFrame(draw);
      else onComplete && onComplete();
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [onComplete, duration]);

  return <canvas ref={canvasRef} className="w-[320px] h-[320px]" data-testid="radar-scanner" />;
}
